import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import { useUrlState } from "../../../hooks/useUrlState.js";
import { usePaginationState } from "../../../hooks/usePaginationState/index.js";
import { REFS_LINKS_BY_TYPE_SELECT_OPTIONS } from "../RefsByTypeTitles/constants.js";
import { RefLinkDetailModal } from "../RefLinkDetailModal.js";
import { RefLinkFormModal } from "../RefLinkForm/RefLinkFormModal.js";
import { RefLinksTable } from "../RefLinksTable.js";
import { useState } from "react";
import { Button, Icon, Select } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdAddLink } from "react-icons/md";
//#region src/modules/shared/RefLinksForRefInteractive/index.tsx
function RefLinksForRefInteractive({ forRef }) {
	const [showRefLinkFormModal, setShowRefLinkFormModal] = useState();
	const [setShowRefLinkDetailModal, setSetShowRefLinkDetailModal] = useState();
	const [filter, setFilter] = useUrlState("rflkfltr", void 0, { dataType: "array" });
	const pagination = usePaginationState(`rflkpg_${forRef.value}`, [filter]);
	const { call, data } = useRPC(RPCs.RefLinks.GetRefLinks.v1, {
		pagination: {
			limit: pagination.recordsPerPage,
			skip: pagination.skippedRecords
		},
		refTypes: filter ? filter : void 0,
		refValue: forRef.value
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "pr-xxs",
		children: [
			showRefLinkFormModal && /* @__PURE__ */ jsx(RefLinkFormModal, {
				closeHandler: () => setShowRefLinkFormModal(void 0),
				controller: forRef,
				onComplete: call,
				refLinkId: typeof showRefLinkFormModal === "string" ? showRefLinkFormModal : void 0
			}),
			setShowRefLinkDetailModal && /* @__PURE__ */ jsx(RefLinkDetailModal, {
				closeHandler: () => setSetShowRefLinkDetailModal(void 0),
				onClickEdit: () => {
					setShowRefLinkFormModal(setShowRefLinkDetailModal);
					setSetShowRefLinkDetailModal(void 0);
				},
				forRef,
				refLinkId: setShowRefLinkDetailModal
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "mb-4 flex items-center justify-between",
				children: [/* @__PURE__ */ jsx(Select, {
					multi: true,
					options: REFS_LINKS_BY_TYPE_SELECT_OPTIONS,
					onChangeValue: setFilter,
					placeholder: "Filter by type...",
					value: filter
				}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(Button, {
					className: "space-x-xxs flex items-center",
					onClick: () => setShowRefLinkFormModal(true),
					variant: "main",
					children: [/* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(Icon, { Icon: MdAddLink }) }), /* @__PURE__ */ jsx("span", { children: "Add Ref" })]
				}) })]
			}),
			/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(RefLinksTable, {
				onClickRow: setSetShowRefLinkDetailModal,
				refLinksData: data,
				forRef,
				pagination
			}) })
		]
	});
}
//#endregion
export { RefLinksForRefInteractive };

//# sourceMappingURL=index.js.map